export default defineNuxtRouteMiddleware(async () => {
  const tenantSettings = useTenantSettingsStore()
  await tenantSettings.fetchSettings()

  if (!tenantSettings.hasInventory) {
    return navigateTo('/dashboard')
  }
})
